module.exports = __webpack_public_path__ + "img/多圈圆.5c9aec0e.png";